/*=============================================== Page ===============================================*/

import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { BackToTop, useMaxWidth } from "tsx-library-julseb"

import { DefaultLayout } from "components/layouts/DefaultLayout"
import { Header } from "components/layouts/Header"
import { Nav } from "components/layouts/Nav"
import { Container } from "./Container"

import type { DefaultLayoutProps } from "components/layouts/DefaultLayout"

import { siteData } from "data"

export const Page = ({
    title,
    description,
    keywords,
    children,
}: DefaultLayoutProps) => {
    const location = useLocation().pathname

    const isMobile = useMaxWidth(1024)

    const [isNavOpen, setIsNavOpen] = useState(true)

    useEffect(() => {
        if (isMobile) setIsNavOpen(false)
    }, [isMobile])

    return (
        <DefaultLayout
            title={title}
            description={
                description
                    ? description
                    : location === "/"
                    ? siteData.description
                    : `${title} for ${siteData.name}`
            }
            keywords={[title, keywords]}
        >
            <Header />

            <Nav isOpen={isNavOpen} setIsOpen={setIsNavOpen} />

            <Container isNavOpen={isNavOpen}>{children}</Container>

            <BackToTop text="Back to top" showText="hover" />
        </DefaultLayout>
    )
}
